import { render } from "./BoxLayout.vue?vue&type=template&id=1702475b&scoped=true"
import script from "./BoxLayout.vue?vue&type=script&lang=js"
export * from "./BoxLayout.vue?vue&type=script&lang=js"

import "./BoxLayout.vue?vue&type=style&index=0&id=1702475b&scoped=true&lang=css"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1702475b"]])

export default __exports__